module.exports = __webpack_public_path__ + "static/media/upload_mp3.c0f9dbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload_mp3.png
// module id = 1460
// module chunks = 1